import { Divider, IconButton, Menu, MenuItem } from '@mui/material'
import { MenuIcon, MyProfileIcon } from '../../assets/icons'
import { PWC } from '../../assets/icons/PWC'
import { UserIcon } from '../../assets/icons/UserIcon'

const Header = ({
  setIsMobileOpen,
  user,
  handleClick,
  anchorEl,
  open,
  handleClose,
  handleLogout,
}) => (
  <header className="bg-white shadow-sm border-b border-[var(--border-subtel)] flex-shrink-0">
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="flex justify-between items-center h-16">
        <button
          type="button"
          onClick={() => setIsMobileOpen(true)}
          className="lg:hidden p-2 rounded-md text-gray-600 hover:bg-gray-100"
          aria-label="Open navigation"
        >
          <MenuIcon className="h-6 w-6" />
        </button>

        <div className="flex items-center lg:hidden">
          <div className="text-orange-600 text-xl font-bold mr-1">
            <PWC />
          </div>
          <div className="text-[var(--forbrand-primary)] text-[16px]">
            Navigate Withholding Tax
          </div>
        </div>

        <div className="hidden lg:flex items-center">
          <div className="text-orange-600 text-2xl font-bold">
            <PWC />
          </div>
          <div className="ml-2 text-[var(--forbrand-primary)] text-[16px]">
            Navigate Withholding Tax
          </div>
        </div>

        <IconButton
          onClick={handleClick}
          color="inherit"
          aria-label="Open user menu"
          sx={{
            backgroundColor: 'var(--table-header-bg)',
            borderRadius: '50% !important',
            width: 40,
            height: 40,
          }}
        >
          <UserIcon />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleClose}>
            <div className="flex gap-3">
              <MyProfileIcon />
              <div className="text-[16px] text-[var(--forbrand-primary)]">
                {user}
              </div>
            </div>
          </MenuItem>
          <Divider />
          <MenuItem
            className="text-[16px] text-[var(--forbrand-primary)]"
            onClick={handleLogout}
          >
            Logout
          </MenuItem>
        </Menu>
      </div>
    </div>
  </header>
)

export default Header
